<template>
<div>
  <div v-if="profile_loaded == false">
    <center>
      <br>
      <Preloader v-if="error_msg_pl==''" class="preload"></Preloader>
      <br>
      <span  v-if="error_msg_pl==''" class="green-text">Loading Profile...</span> 
      <span v-else  class="red-text">{{error_msg_pl}}</span>   
    </center>
  </div>

  <div v-else id="profile">
    <div class="row" style="padding-top:10px;">
      <div id="id_profile_pic" class="col s12 m3 l2 hide-on-small-and-down">
        <img
          class="circle"
          src="https://media-exp1.licdn.com/dms/image/C5603AQGouCLWPE5_tg/profile-displayphoto-shrink_200_200/0?e=1596672000&v=beta&t=Mt8YhHtJOOwxsX9MYtMS8oSL2QzqtFF7mTOug_RBUms"
        />
      </div>

      <div id="id_activity_pics" class="col s12 m9 l10">
        <div class="slider">
          <ul class="slides">
            <li>
              <img src="https://materializecss.com/images/sample-1.jpg" />
              <!-- random image -->
              <div class="caption center-align">
                <h3>This is our big Tagline!</h3>
                <h5 class="light grey-text text-lighten-3">Here's our small slogan.</h5>
              </div>
            </li>
            <li>
              <img src="http://lorempixel.com/800/400/nature/2/" />
              <!-- random image -->
              <div class="caption left-align">
                <h3>Left Aligned Caption</h3>
                <h5 class="light grey-text text-lighten-3">Here's our small slogan.</h5>
              </div>
            </li>
            <li>
              <img src="https://lorempixel.com/580/250/nature/3/" />
              <!-- random image -->
              <div class="caption right-align">
                <h3>Right Aligned Caption</h3>
                <h5 class="light grey-text text-lighten-3">Here's our small slogan.</h5>
              </div>
            </li>
            <li>
              <img src="https://lorempixel.com/580/250/nature/4/" />
              <!-- random image -->
              <div class="caption center-align">
                <h3>This is our big Tagline!</h3>
                <h5 class="light grey-text text-lighten-3">Here's our small slogan.</h5>
              </div>
            </li>
          </ul>
        </div>
        <img
          id="pp_sm"
          class="circle hide-on-med-and-up"
          src="https://media-exp1.licdn.com/dms/image/C5603AQGouCLWPE5_tg/profile-displayphoto-shrink_200_200/0?e=1596672000&v=beta&t=Mt8YhHtJOOwxsX9MYtMS8oSL2QzqtFF7mTOug_RBUms"
        />
      </div>

      <div id="id_social_links" class="col s12 m12 l12 blue">
        <i class="fa fa-facebook"></i>
        <span class="hide-on-med-and-down1">Facebook</span>
        <i class="fa fa-instagram"></i>
        <span class="hide-on-med-and-down1">Instagram</span>
        <i class="fa fa-linkedin"></i>
        <span class="hide-on-med-and-down1">LinkedIn</span>
        <i class="fa fa-twitter"></i>
        <span class="hide-on-med-and-down1">Twitter</span>
      </div>

      <div id="id_user_bio" class="col s12 m12 l12">
        <span>
          <b>About Me:</b>
        </span>
        {{profile_data.user_bio.dob}}
        <br />
        <span>
          <b>Passion:</b>
        </span>
        {{profile_data.user_bio.passion}}
        <br />
        <span>
          <b>Profession:</b>
        </span>
        {{profile_data.user_bio.profession}}
        <br />
        <span>
          <b>sex:</b>
        </span>
        {{profile_data.user_bio.sex}}
        
      </div>

      <span class="divider" tabindex="-1"></span>
    </div>
  </div>
</div>
</template>

<script>
import db from "./firebaseInit";
import Preloader from "./Preloader";

export default {
  name: "dashboard",
  components: {
    Preloader
  },
  data() {
    return {    };
  },

  created() {
    
  },
  
  methods: {

  },

  computed: {
    profile_loaded:function() {
      console.log("in Profile->computed.profile_loaded()");
      return this.$store.state.profile_loaded;
    },

    error_msg_pl:function(){
      return this.$store.state.error_msg_pl;      

    },

    profile_data:function(){
      console.log("in Profile->computed.profile_data()");
      return this.$store.state.profile_data;      
    },
  },

  mounted: function() {
    console.log("in Profile->Mounted");
    this.$store.dispatch("loadProfileInfo"); //It will call the loadLinksInfo method in action of store.js

    //delay for few sec to ensure that dom is loaded, else slider doesnt starts
    setTimeout(function() {
      $(".slider").slider();
      var tbl_width = $("#tblid_list").width();
      $("#txtid_search_link").width(tbl_width - 5);
    }, 2000);

  }
};
</script>


<style scoped>
#loader {
  height: 600px;
}

.preload {
  margin: 10px;
}
.srno {
  width: 10px;
  background: gray;
  font-size: 18px;
}
.chip {
  width: 35px;
}
.linkdesc {
  color: gray;
  text-align: justify;
}

.list_text {
  font-size: 15px;
}
#txtid_search_link {
  background: #f6f6f8;
  padding-left: 5px;
  margin-left: 2px;
  border-radius: 2px;
}

#divid_tblwraper {
  min-height: 450px;
  border: solid 1px gray;
  border-radius: 5px;
}

td {
  padding: 5px;
}
#divid_search {
  background: black;
}

.fix_top {
  position: fixed;
  top: 50px;

  z-index: 200;
}

.circle {
  width: 125px;
  border: solid 1px white;
}

#id_profile_pic,
#id_activity_pics,
#id_social_links,
#id_user_bio {
  background: #eeeeee;
  border-radius: 5px;
  border: solid 1px #eeeeee;
}

#id_profile_pic {
  height: 200px;
  padding-top: 40px;
  background: black;
}

#id_activity_pics {
  height: 200px;
  background: black;
}

#id_social_links {
  background: #f6f6f8;
  font-size: 14px;
  text-align: justify;
}

#id_user_bio {
  padding-top: 5px;
  margin-top: 5px;
}

.slider,
ul {
  width: 100%;
  height: 100% !important;
}

#pp_sm {
  width: 100px;
  position: relative;
  top: -185px;
  left: 15px;
  z-index: 50;
}
</style>




// WEBPACK FOOTER //
// src/components/Profile.vue